import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const WHATSAPP_NUMBER = "50588147585";
export const WHATSAPP_DISPLAY = "+505 8814 7585";
export const PHONE = "+505 8522 9964";
export const PHONE_TEL = "tel:+50585229964";
export const EMAIL = "DraCoraSJ@gmail.com";
export const INSTAGRAM = "https://www.instagram.com/dr._cora";
export const FACEBOOK = "https://www.facebook.com/198439090217491";
export const FACEBOOK_REVIEWS = "https://facebook.com/198439090217491/reviews";
export const SUNCARE = "http://www.suncaredental.com/";

export const WHATSAPP_SJDS = "50586321846";
export const WHATSAPP_MANAGUA = "50589415471";

export const waLink = (text = "Hello Dr. Cora! I'd like to book an appointment.", number = WHATSAPP_NUMBER) =>
  `https://wa.me/${number}?text=${encodeURIComponent(text)}`;

export const imgUrl = (src) => (src && src.startsWith("/api/") ? `${BACKEND_URL}${src}` : src);

export const submitLead = (data) =>
  axios.post(`${API}/leads`, { ...data, page: window.location.pathname });

const sessionId = () => {
  let id = sessionStorage.getItem("cora_sid");
  if (!id) {
    id = Math.random().toString(36).slice(2) + Date.now().toString(36);
    sessionStorage.setItem("cora_sid", id);
  }
  return id;
};

export const trackView = (path) => {
  axios
    .post(`${API}/track`, {
      path,
      referrer: document.referrer,
      session_id: sessionId(),
      mobile: window.innerWidth < 768,
    })
    .catch(() => {});
};
